export default __webpack_public_path__ + "static/media/es.05fa44b4.svg";